import { render, staticRenderFns } from "./AddressPickerBlock.vue?vue&type=template&id=61987725&scoped=true&"
import script from "./AddressPickerBlock.vue?vue&type=script&lang=js&"
export * from "./AddressPickerBlock.vue?vue&type=script&lang=js&"
import style0 from "./AddressPickerBlock.vue?vue&type=style&index=0&id=61987725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61987725",
  null
  
)

export default component.exports